import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';

const PrivateRoute = ({ children, requiredUserType = null }) => {
  const { isAuthenticated, userType, loading, profile } = useAuth();
  const location = useLocation();

  // Show loading while checking auth status
  if (loading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Checking authentication...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check user type if required
  if (requiredUserType) {
    // Special handling for host routes
    if (requiredUserType === 'host') {
      const isApprovedHost = profile?.is_host && profile?.host_status === 'approved';
      const isAdmin = userType === 'admin';

      // Allow access for approved hosts or admins
      if (!isApprovedHost && !isAdmin) {
        return (
          <div className="access-denied">
            <h2>Host Access Required</h2>
            <p>You need to be an approved host to access this area.</p>
            {profile?.is_host && profile?.host_status === 'pending' && (
              <p>Your host application is currently pending approval.</p>
            )}
            {!profile?.is_host && (
              <p>
                <a href="/become-a-host">Apply to become a host</a>
              </p>
            )}
          </div>
        );
      }
    } else if (userType !== requiredUserType) {
      // Standard user type check for other routes
      return (
        <div className="access-denied">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p>
            Required: {requiredUserType}, Your type: {userType}
          </p>
        </div>
      );
    }
  }

  return children;
};

export default PrivateRoute;
